module.exports = __webpack_public_path__ + "static/media/pineapple.34999d99.svg";